import React, { useEffect, useState } from "react";
import DevicePlacesTable from "./components/DevicePlacesTable";
import Edit from "./modals/Edit";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Filter from "./modals/Filter";
import Divider from "@material-ui/core/Divider/index";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import axios from "axios";
import { useSelector } from "react-redux";
import { updateObject } from "../../../helpers/updateObject";
import Log from "./Log"

function DevicePlaces(props) {
  const token = useSelector((state) => state.auth.token);
  const [devicePlaces, setDevicePlaces] = useState([]);
  const [chooseDevicePlaceId, setChooseDevicePlaceId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteDevicePlacesIds, setDeleteDevicePlacesIds] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [showLog, setShowLog] = useState(false);
  const [filterInputs, setFilterInputs] = useState({
    name: "",
  
  });

  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onDevicePlaces = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {
      name,
      
    } = filterInputs;
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}devicePlace?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${name ? `&name=${name}` :""}`, {
        headers: { Authorization: `bearer ${token}` },
      })
      .then(({ data: { content ,totalElements} }) => {
        setIsLoading(false);
        setDevicePlaces(content);
        setIsError(false);
        setCount(totalElements)
      })
      .catch(() => {
        setIsLoading(false);
        setDevicePlaces([]);
        setIsError(true);
      });
  };

  const onDevicePlaceChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}devicePlace/${id}`, {
      headers: { Authorization: `bearer ${token}` },
    });
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onDevicePlaces(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);


  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Qurğu məkanı</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <DevicePlacesTable
        devicePlaces={devicePlaces}
        isLoading={isLoading}
        isError={isError}
        setChooseDevicePlaceId={setChooseDevicePlaceId}
        setShowCreate={setShowCreate}
        setShowRemove={setShowRemove}
        setShowEdit={setShowEdit}
        setDeleteDevicePlacesIds={setDeleteDevicePlacesIds}
        deleteDevicePlacesIds={deleteDevicePlacesIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setShowLog={setShowLog}
      />
      {showCreate && (
        <Create
          show={showCreate}
          onHide={setShowCreate}
          onDevicePlaces={onDevicePlaces}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
        filterInputs={filterInputs}

        />
      )}

   

      {showRemove && (
        <Delete
          id={chooseDevicePlaceId}
          show={showRemove}
          onHide={setShowRemove}
          onDevicePlaces={onDevicePlaces}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
        filterInputs={filterInputs}

        />
      )}


      {showEdit && (
        <Edit
          show={showEdit}
          onHide={setShowEdit}
          onDevicePlaces={onDevicePlaces}
          id={chooseDevicePlaceId}
          onDevicePlaceChoose={onDevicePlaceChoose}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}

        />
      )}


      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}

      />
           <Log
        chooseDevicePlaceId={chooseDevicePlaceId}
        onDevicePlaceChoose={onDevicePlaceChoose}
        onDevicePlaces={onDevicePlaces}
        filterInputs={filterInputs}
        setChooseDevicePlaceId={setChooseDevicePlaceId}
        showLog={showLog}
        setShowLog={setShowLog}

      />
     
    </div>
  );
}

export default DevicePlaces;
